import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "./Header";
import Footer from "../LandingPage/Footer";
import axios from "axios";


const API_BASE = "https://api.propertygalleria.in/master/api";

const Saved = () => {
  const [savedProducts, setSavedProducts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const data = JSON.parse(localStorage.getItem("wishlist")) || [];
    setSavedProducts(data);
  }, []);

  const removeFromWishlist = (id) => {
    const updated = savedProducts.filter(item => item.id !== id);
    localStorage.setItem("wishlist", JSON.stringify(updated));
    setSavedProducts(updated);
  };

  // if (savedProducts.length === 0) {
  //   return <h2 style={{ textAlign: "center" }}>No saved properties ❤️</h2>;
  // }


  console.log('this is savedProducts', savedProducts)



  return (
    <>
      <Header />
      <div style={{ padding: 20, paddingTop: "100px" }}>
        <h2>Saved Properties</h2>

        <div style={{ display: "flex", flexWrap: "wrap", gap: 20 }}>
          {/* {savedProducts.map((p) => (
            <div key={p.id} style={card}>

              <div style={{ position: "relative" }}>
                <img
                  src={p.image}
                  alt=""
                  style={image}
                  onClick={() => navigate(`/property`)}
                />

                <div
                  style={{ ...heartIcon, color: "red" }}
                  onClick={() => removeFromWishlist(p.id)}
                >
                  ❤️
                </div>
              </div>

              <div style={{ padding: 15 }}>
                <h3>{p.title}</h3>
                <p>📍 {p.location}</p>
                <strong>{p.price}</strong>
              </div>
            </div>
          ))} */}


          {savedProducts.map((p) => (
            <div key={p.id} style={card}>

              {/* IMAGE SCROLL */}
              {/* <div style={imageWrapper}>
                <div style={imageScroll}>
                  {p.property_images?.map((img, index) => (
                    <img
                      key={index}
                      src={img}
                      alt={p.title}
                      style={image}
                      onClick={() => navigate(`/property/${p.id}`)}
                    />
                  ))}
                </div>

                <div style={badge}>{p.category}</div>

                <div
                  style={{ ...heartIcon, color: "red" }}
                  onClick={() => removeFromWishlist(p.id)}
                >
                  ❤️
                </div>
              </div> */}

              <div style={imageWrapper}>
                <div style={imageScroll}>
                  {p.property_images?.map((img, index) => (
                    <img
                      key={index}
                      src={img}
                      alt={p.title}
                      style={image}
                      onClick={() => navigate(`/properties/${p.id}`)}
                    />
                  ))}
                </div>

                {/* IMAGE COUNT */}
                <div style={imageCount}>
                  1 / {p.property_images?.length || 1}
                </div>

                {/* CATEGORY BADGE */}
                <div style={badge}>{p.category}</div>

                {/* HEART */}
                <div
                  style={{ ...heartIcon, color: "red" }}
                  onClick={() => removeFromWishlist(p.id)}
                >
                  ❤️
                </div>
              </div>


              {/* DETAILS */}
              {/* <div style={{ padding: 15 }}>
                <h3 style={{ margin: "5px 0" }}>{p.title}</h3>
                <p style={{ margin: "5px 0", color: "#666" }}>
                  📍 {p.location} • {p.zone_desc}
                </p>
                <p style={{ margin: "5px 0" }}>📐 {p.area} sq.ft</p>
                <strong style={{ color: "#2e7d32" }}>
                  ₹ {Number(p.price).toLocaleString("en-IN")}
                </strong>
              </div> */}
              <div style={{ padding: 15, flexGrow: 1 }}>
                <h3 style={{ margin: "6px 0" }}>{p.title}</h3>

                <p style={{ margin: "4px 0", color: "#666" }}>
                  📍 {p.location} • {p.zone_desc}
                </p>

                <p style={{ margin: "4px 0" }}>
                  📐 {p.area} sq.ft
                </p>

                <strong style={{ color: "#2e7d32" }}>
                  ₹ {Number(p.price).toLocaleString("en-IN")}
                </strong>
              </div>

            </div>
          ))}

        </div>
      </div>

      <Footer />
    </>
  );
};

export default Saved;

// const card = {
//   minWidth: 300,
//   background: "#fff",
//   borderRadius: 16,
//   boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
//   overflow: "hidden"
// };

const card = {
  width: 420,               // SAME WIDTH for all
  height: 420,              // SAME HEIGHT for all
  background: "#fff",
  borderRadius: 16,
  boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
  overflow: "hidden",
  display: "flex",
  flexDirection: "column"
};
const imageWrapper = {
  position: "relative",
  height: 220,          // SAME image height for all cards
  overflow: "hidden"
};

const imageScroll = {
  display: "flex",
  height: "100%",
  overflowX: "auto",
  scrollSnapType: "x mandatory"
};

const image = {
  minWidth: "100%",
  height: "100%",
  objectFit: "cover",
  scrollSnapAlign: "start",
  cursor: "pointer"
};

// const image = {
//   width: "100%",
//   height: 180,
//   objectFit: "cover"
// };


const heartIcon = {
  position: "absolute",
  top: 12,
  right: 12,
  background: "#fff",
  borderRadius: "50%",
  width: 36,
  height: 36,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: 18,
  cursor: "pointer",
  zIndex: 10
};

// const imageWrapper = {
//   position: "relative",
//   overflow: "hidden"
// };

// const imageScroll = {
//   display: "flex",
//   overflowX: "auto",
//   scrollSnapType: "x mandatory"
// };

// const image = {
//   minWidth: "100%",
//   height: 180,
//   objectFit: "cover",
//   scrollSnapAlign: "start",
//   cursor: "pointer"
// };

const badge = {
  position: "absolute",
  top: 12,
  left: 12,
  background: "#1976d2",
  color: "#fff",
  padding: "4px 10px",
  borderRadius: 12,
  fontSize: 12,
  fontWeight: "bold",
  zIndex: 10
};
const imageCount = {
  position: "absolute",
  bottom: 12,
  right: 12,
  background: "rgba(0,0,0,0.65)",
  color: "#fff",
  padding: "4px 8px",
  borderRadius: 8,
  fontSize: 12,
  zIndex: 10
};
